import { Box, Button, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import storeyviewLogo from '../../assets/logos/sv_logo_green.png';
import { theme } from '../../theme';
import Header from './Header';

const CREAM = '#faf7f1';

const SUPPORT_CARDS = [
  {
    icon: <DescriptionOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '1.2rem' }} />,
    title: 'Documentation',
    description: 'Step-by-step guides and how-tos for every part of the platform.',
    link: '',
  },
  {
    icon: <EmailOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '1.2rem' }} />,
    title: 'Email support',
    description: 'Answered by the in-house team, usually within hours.',
    link: 'info@rdsbrokerage.com',
  },
  {
    icon: <SchoolOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '1.2rem' }} />,
    title: 'Onboarding & training',
    description: 'Hands-on setup and team training for every new launch.',
    link: 'Request onboarding',
  },
];

const Support = () => {
  return (
    <Box sx={{ backgroundColor: CREAM, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header showLoginButton />

      <Box
        sx={{
          padding: '60px',
          '@media (max-width: 600px)': { padding: '30px 20px' },
        }}
      >
        <Typography sx={{ fontSize: '0.75rem', letterSpacing: '2px', color: theme.palette.secondary.main, fontWeight: 600, mb: 1 }}>
          SUPPORT
        </Typography>
        <Typography sx={{ fontSize: '2.5rem', color: '#1a1a1a', lineHeight: 1.2, mb: 2, '@media (max-width: 600px)': { fontSize: '1.8rem' } }}>
          We're here to help.
        </Typography>
        <Typography sx={{ fontSize: '1rem', color: '#1a1a1a', mb: 4, maxWidth: '640px' }}>
          Reach the team behind Storeyview - built and run in-house at RDS, so answers come from the people who made
          it.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: '24px',
            flexWrap: 'wrap',
            mb: 4,
          }}
        >
          {SUPPORT_CARDS.map((card) => (
            <Box
              key={card.title}
              sx={{
                flex: 1,
                minWidth: '260px',
                backgroundColor: '#ffffff',
                borderRadius: '6px',
                padding: '24px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.06)',
              }}
            >
              <Box
                sx={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  backgroundColor: '#eef0ec',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                }}
              >
                {card.icon}
              </Box>
              <Typography sx={{ fontWeight: 700, color: '#1a1a1a', mb: 1 }}>{card.title}</Typography>
              <Typography sx={{ fontSize: '0.9rem', color: '#1a1a1a', mb: 1.5 }}>{card.description}</Typography>
              <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: theme.palette.secondary.main }}>
                {card.link}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            borderRadius: '6px',
            padding: '24px 40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px',
          }}
        >
          <Typography sx={{ fontSize: '1rem', color: '#ffffff' }}>
            <Box component="span" sx={{ fontWeight: 700 }}>
              Launching soon?
            </Box>{' '}
            <Box component="span" sx={{ color: theme.palette.secondary.main }}>
              Talk to your RDS account team.
            </Box>
          </Typography>
          <Button
            component="a"
            href="https://rdsbrokerage.com/contact/"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            sx={{
              backgroundColor: theme.palette.secondary.main,
              color: theme.palette.primary.main,
              letterSpacing: '1px',
              fontSize: '0.75rem',
              '&:hover': { backgroundColor: theme.palette.secondary.main },
            }}
          >
            Contact Us
          </Button>
        </Box>
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          backgroundColor: theme.palette.primary.main,
          padding: '40px 60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '20px',
          marginTop: 'auto',
          '@media (max-width: 600px)': { padding: '30px 20px' },
        }}
      >
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <img
              src={storeyviewLogo}
              alt="storeyview"
              style={{ height: '20px', filter: 'brightness(0) invert(1)' }}
            />
          </Box>
          <Typography sx={{ fontSize: '0.8rem', color: '#d8d8d0' }}>An RDS company</Typography>
          <Typography sx={{ fontSize: '0.8rem', color: theme.palette.secondary.main, letterSpacing: '1px' }}>STOREYVIEW.COM</Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '24px' }}>
          <Typography
            component="a"
            href="https://rdsbrokerage.com/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontSize: '0.8rem', color: '#d8d8d0', letterSpacing: '1px', textDecoration: 'none' }}
          >
            PRIVACY
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Support;
